export default {
    outdoorsLocalizationTeams: [],
    outdoorsLocalizationTeamsLoading: false,
    filters: setInitialFilters(),
    setInitialFilters: setInitialFilters
}

function setInitialFilters() {
    return {
        name: null
    }
}
